import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Skeleton,
} from "@mui/material";
import axios from "axios";
import {
  AutoCompleteComponent,
  FormLabel,
  ModalError,
  ModalSuccess,
  MultipleSelectInput,
  PrimaryButton,
  SecondaryButton,
  TextInput,
} from "components";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { arrayToCommaSeparatedString, getErrors } from "utils";

const ModalFormParameterTerritory = ({
  open,
  onClose,
  preload,
  optionCountry,
  getDataTable,
}) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [payload, setPayload] = useState({
    territory_name: "",
    territory_type_flag: "",
    territory_code: "",
    territory_ext_code: "",
    country: [],
  });

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleChangeCountry = (e, option) => {
    const { checked } = e?.target || false;
    setPayload(prev => ({
      ...prev,
      country: checked
        ? [...prev?.country, option]
        : prev?.country?.filter(item => item?.id !== option?.id),
    }));
  };

  const getDetail = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/admin/territory/${preload}`, {
        headers,
      });
      const { data } = res?.data;
      const modifiedData = {
        ...data,
        country: (data?.territory_countries || [])?.map(
          ({ country }) => country
        ),
      };
      setPayload(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSubmit = async () => {
    const method = preload ? axios.put : axios.post;
    const { country, ...restPayload } = payload;
    const modifiedPayload = {
      ...restPayload,
      country_ids: country?.map(item => item?.id),
      description: "",
      is_the_world_flag: false,
      is_usa_flag: false,
      parent_territory_id: 0,
    };

    try {
      setLoadingButton(true);
      await method(
        `${hardBaseUrl}/admin/territory${preload ? `/${preload}` : ""}`,
        modifiedPayload,
        { headers }
      );
      ModalSuccess(
        `Successfully ${preload ? "update" : "save"} territory`
      ).then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
      onClose();
    }
  };

  useEffect(() => {
    if (preload) {
      getDetail();
    }
  }, [preload]);

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>{`${preload ? "Edit" : "Add"} Territory`}</DialogTitle>
      <DialogContent dividers>
        {loadingPage ? (
          <Grid container direction="column" rowSpacing={2}>
            {Array.from({ length: 5 }).map((_, index) => (
              <Grid item key={index}>
                <Box mb="8px">
                  <Skeleton variant="rounded" width="40%" height={25} />
                </Box>
                <Skeleton variant="rounded" width="100%" height={30} />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid container direction="column" rowSpacing={2}>
            {MockFieldTerritory.map(({ key, title }) => (
              <Grid item key={key}>
                <FormLabel label={title} required />
                <TextInput
                  disabled={loadingButton}
                  placeholder={title}
                  value={payload?.[key]}
                  onChange={e => handleChangePayload(e?.target?.value, key)}
                />
              </Grid>
            ))}
            <Grid item>
              <FormLabel label="Territory Type" required />
              <AutoCompleteComponent
                options={optionTerritoryType}
                value={
                  optionTerritoryType.find(
                    option => option.id === payload?.territory_type_flag
                  ) || null
                }
                onChange={value =>
                  handleChangePayload(value, "territory_type_flag")
                }
                placeholder="Select Territory Type"
                width="100%"
                size="small"
              />
            </Grid>
            <Grid item>
              <FormLabel label="Country" required />
              <MultipleSelectInput
                options={optionCountry}
                multiple
                optionKey="id"
                optionLabel="country_name"
                value={payload?.country || ""}
                textValue={arrayToCommaSeparatedString(
                  payload?.country,
                  "country_name"
                )}
                onChange={(e, option) => handleChangeCountry(e, option)}
                placeholder="Country"
                width="100%"
              />
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          label="Cancel"
          disabled={loadingPage}
          onClick={onClose}
        />
        <PrimaryButton
          label={loadingButton ? "Saving" : "Save"}
          loading={loadingButton}
          disabled={loadingPage || loadingButton}
          onClick={handleSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};

const MockFieldTerritory = [
  {
    key: "territory_name",
    title: "Territory Name",
  },
  {
    key: "territory_code",
    title: "TIS-A",
  },
  {
    key: "territory_ext_code",
    title: "TIS-A-Ext",
  },
];

const optionTerritoryType = [
  {
    label: "Country",
    value: "Country",
    id: "Country",
  },
  {
    label: "Economical Country-G",
    value: "Economical",
    id: "Economical",
  },
  {
    label: "Geographical Country",
    value: "Geographical",
    id: "Geographical",
  },
  {
    label: "Political Country-Gro",
    value: "Political",
    id: "Political",
  },
];
export default ModalFormParameterTerritory;
